<template>
  <div>
    <div v-if="planPaymentMethods.length > 1" class="tw-flex tw-justify-end tw-mb-3">
      <base-button size="sm" @click="$refs.editPlanPaymentMethodModal.show(planPaymentMethods)">Update All</base-button>
    </div>
    <base-list-group v-if="arePlansLoading">
      <base-list-item v-for="i in planPaymentMethods.length || 3" :key="i">
        <div class="tw-flex tw-justify-between tw-items-center">
          <div>
            <div class="tw-flex tw-items-center tw-mt-1.5 tw-mb-1">
              <base-skeleton-loader class="tw-w-24 tw-h-3" />
            </div>
            <base-skeleton-loader class="tw-w-12 tw-h-2 tw-mt-2.5 tw-mb-0.5" />
          </div>
          <div>
            <div class="tw-flex tw-justify-between tw-items-center">
              <div class="tw-flex">
                <base-skeleton-loader class="tw-h-4 tw-w-5 tw-mt-0.5" />
                <div class="tw-ml-3 tw-text-sm">
                  <base-skeleton-loader class="tw-h-3 tw-mb-1.5 tw-mt-0.5 tw-w-10" />
                  <base-skeleton-loader class="tw-h-2 tw-my-1 tw-w-8 tw-mt-2.5" />
                </div>
              </div>
              <base-skeleton-loader class="tw-rounded-full tw-h-5 tw-w-5 tw-ml-8" />
            </div>
          </div>
        </div>
      </base-list-item>
    </base-list-group>
    <base-list-group v-else>
      <base-list-item v-for="plan in planPaymentMethods" :key="plan.serBusinessPlanId">
        <div class="tw-flex tw-justify-between tw-items-center">
          <div>
            <div>{{ plan.planName }}</div>
            <div class="tw-text-gray-600 tw-text-sm tw-leading-none">{{ plan.businessName }}</div>
          </div>
          <div class="tw-flex tw-items-center">
            <div class="tw-flex">
              <credit-card-icon class="tw-text-gray-700 tw-h-4 tw-text-lg tw-mt-0.5" :name="plan.brand" />
              <div class="tw-ml-3 tw-text-sm" v-if="plan.last4">
                <div>**** {{ plan.last4 }}</div>
                <div class="tw-text-gray-500 tw-text-xs">Exp {{ expDate(plan.expirationMonth, plan.expirationYear) }}</div>
              </div>
              <div class="tw-ml-3 tw-text-gray-500" v-else>No Card</div>
            </div>
            <base-icon class="tw-ml-2.5" @click="$refs.editPlanPaymentMethodModal.show([plan])">
              <edit-icon class="tw-w-3.5 tw-h-3.5" />
            </base-icon>
          </div>
        </div>
      </base-list-item>
    </base-list-group>
    <edit-plan-payment-method-modal ref="editPlanPaymentMethodModal" :user-id="userId" @updated="loadPlanPaymentMethods()" />
  </div>
</template>

<script>
import EditPlanPaymentMethodModal from "@/views/user/components/EditPlanPaymentMethodModal";
import { EditIcon } from "@/assets/svgs";
import { padStart } from "lodash";
import CreditCardIcon from "@/components/CreditCardIcon";

export default {
  components: {
    EditPlanPaymentMethodModal,
    EditIcon,
    CreditCardIcon,
  },
  props: {
    userId: String,
    businessId: String,
  },
  data() {
    return {
      arePlansLoading: false,
      planPaymentMethods: [],
    };
  },
  methods: {
    async loadPlanPaymentMethods() {
      try {
        this.arePlansLoading = true;
        const response = await this.$axios.get(`/businesses/${this.businessId}/members/${this.userId}/paymentmethods`);
        this.planPaymentMethods = response.data;
      } finally {
        this.arePlansLoading = false;
      }
    },
    expDate(expMonth, expYear) {
      return `${padStart(expMonth, 2, "0")} / ${expYear.toString().slice(-2)}`;
    },
  },
  created() {
    this.loadPlanPaymentMethods();
  },
  watch: {
    userId() {
      this.loadPlanPaymentMethods();
    },
  },
};
</script>
